import { defa } from 'defa-object';

const channelLang = Bb.Radio.channel( 'lang' );

/**
 * Uses localstorage to find and set language.
 */
export default class LanguageSettings {
	
	/**
	 * constructor
	 * @param lang
	 */
	constructor( lang ) {
		
		if ( lang ) {
			this.lang = lang;
		} else if ( window.localStorage.lang ) {
			this.lang = window.localStorage.lang;
		} else if ( document.documentElement.lang ) {
			this.lang = document.documentElement.lang;
		} else {
			this.lang = window.navigator.language;
		}
		
		document.documentElement.lang = this.lang;
	}
	
	/**
	 * Attempts to tweak the language variable in known cases.
	 * @param lang {string}  A preferably five character language representation
	 * @returns {string} The tweaked language representation.
	 */
	static closestLang( lang ) {
		
		const l = lang.split( '-' )[ 0 ];
		
		switch ( l ) {
			case 'en':
				return 'en-GB';
			case 'fr':
				return 'fr-CA';
			case 'nb':
				return 'nb-NO';
		}
		if ( !_.findWhere( defa.vars.languages, { languageCode: lang } ) ) {
			console.log( `unknown language: ${ lang }, falling back to en` );
			return 'en-GB';
		}
		
		return lang;
	}
	
	// --------------------------------
	// setters
	// --------------------------------
	
	/**
	 * Sets the language for the application
	 * @param newLang {string} A preferably fice character language representation
	 */
	set lang( newLang ) {
		
		const lang = LanguageSettings.closestLang( newLang );
		
		if ( lang !== newLang ) {
			console.log( `chose ${ lang } instead` );
		}
		
		window.localStorage.lang      = lang;
		document.documentElement.lang = this.lang;
		channelLang.trigger( 'lang', this.lang );
		
		this._lang = lang;
	}
	
	// --------------------------------
	// getters
	// --------------------------------
	
	get lang() {
		return this._lang;
	}
	
	get country() {
		return this.lang.split( '-' )[ 1 ].toLowerCase();
	}
	
	get shortLanguage() {
		return this.lang.split( '-' )[ 0 ].toLowerCase();
	}
}